import { type } from "../types/index";
import SucursalesService from "../services/sucurales.services";
import { UpdateSecurityKey } from "../helpers/SecurityKey";

/*export const updateSucursalSelection = (sucursal) =>({
    type: type.updateSucursalSelection,
    payload: sucursal
}
);*/

export const getSucursales =
  (usuario, securitykey, latitud, longitud) => (dispatch) => {
    dispatch({ type: type.clearMessage });
    dispatch({ type: type.resetSolicitud });
    dispatch({ type: type.setLoading });
    return SucursalesService.getSucursales(
      usuario,
      securitykey,
      latitud,
      longitud,
    ).then(
      (data) => {
        dispatch({ type: type.setLoading });
        const { Codigo, llaveSeguridad } = data;
        if (Codigo === 0) {
          dispatch({
            type: type.getSucursales,
            payload: data.Sucursales,
          });
          UpdateSecurityKey(llaveSeguridad);

          if (!data.Sucursales || data.Sucursales.length === 0) {
            sessionStorage.removeItem("sucursalSeleccionada");
            dispatch({
              type: type.updateSucursalSelection,
              payload: null,
            });
          } else {
            // Seleccionar una sucursal por defecto. Se respeta la
            // seleccion previa (persistida) si aun existe en la lista;
            // de lo contrario se toma la primera sucursal.
            let seleccionGuardada = null;
            try {
              const raw = sessionStorage.getItem("sucursalSeleccionada");
              if (raw && raw !== "undefined" && raw !== "null") {
                seleccionGuardada = JSON.parse(raw);
              }
            } catch (e) {
              seleccionGuardada = null;
            }

            const seleccionValida =
              seleccionGuardada &&
              data.Sucursales.some((s) => s.Clave === seleccionGuardada.Clave);

            const sucursalPorDefecto = seleccionValida
              ? data.Sucursales.find((s) => s.Clave === seleccionGuardada.Clave)
              : data.Sucursales[0];

            sessionStorage.setItem(
              "sucursalSeleccionada",
              JSON.stringify(sucursalPorDefecto),
            );
            dispatch({
              type: type.updateSucursalSelection,
              payload: sucursalPorDefecto,
            });
          }
        } else {
          sessionStorage.removeItem("sucursalSeleccionada");
          dispatch({
            type: type.updateSucursalSelection,
            payload: null,
          });
          dispatch({
            type: type.getSucursalesFail,
          });
          dispatch({
            type: type.setError,
            payload: {
              tipoError: data.Codigo,
              mensajeError: data.Mensaje,
            },
          });
        }
        dispatch({
          type: type.textMessage,
          payload: data,
        });
        return Promise.resolve(data);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({ type: type.setLoading });
        dispatch({
          type: type.getSucursalesFail,
        });
        dispatch({
          type: type.textMessage,
          payload: message,
        });
        dispatch({
          type: type.setError,
          payload: {
            tipoError: 0,
            mensajeError: message,
          },
        });
        return Promise.reject(error);
      },
    );
  };

export const updateSucursalSelection = (sucursal) => (dispatch) => {
  sessionStorage.setItem("sucursalSeleccionada", JSON.stringify(sucursal));
  dispatch({
    type: type.updateSucursalSelection,
    payload: sucursal,
  });
};
